import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React from "react";
import {CheckCircleFilled, CloseCircleFilled, MessageOutlined, SignatureOutlined, UploadOutlined} from "@ant-design/icons"
import Typography from "app/shared/Typography";
import { Button, Tag, Modal, Spin } from "antd";
import { FormattedNumber } from "react-intl";
// Fallback map if VAT global constant is missing
const COUNTRY_ISO_MAP:any = {
    "Denmark": "dk",
    "Netherlands": "nl",
    "France": "fr",
    "United Kingdom": "gb",
    "South Korea": "kr",
    "Bahrain": "bh",
    "Global": "kr"
};


  

const DocumentTracker = () => {

    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [objectUrl, setObjectUrl] = React.useState<string | null>(null);
    const [selectedTemplateId, setSelectedTemplateId] = React.useState<string | null>(null);
    const [signing, setSigning] = React.useState(false);
    const [iframeUrl, setIframeUrl] = React.useState<string | null>(null);
    const iframeRef = React.useRef<HTMLIFrameElement>(null);
    const [error, setError] = React.useState<string | null>(null);
    const [isStarting, setIsStarting] = React.useState(false);
    const [pdfLoading, setPdfLoading] = React.useState(false);

    const handleReviewSign = React.useCallback((params:any) => {
        const templateId = params?.data?.template_id;
        if (!templateId) return;
        setSelectedTemplateId(templateId);
        setObjectUrl(`http://localhost:4000/ds/templates/${templateId}/document`);
        setPdfLoading(true);
        setIsModalOpen(true);
    }, []);

    const getTemplateIdFromGroup = (params:any): string | null => {
        const leaves = params?.node?.allLeafChildren || [];
        for (const leaf of leaves) {
            const tid = leaf?.data?.template_id;
            if (tid) return tid;
        }
        return null;
    };

    const handleReviewSignFromGroup = React.useCallback((params:any) => {
        const templateId = getTemplateIdFromGroup(params);
        if (!templateId) return;
        setSelectedTemplateId(templateId);
        setObjectUrl(`http://localhost:4000/ds/templates/${templateId}/document`);
        setPdfLoading(true);
        setIsModalOpen(true);
    }, []);

    const handleClose = () => {
        setIsModalOpen(false);
        setObjectUrl(null);
        setSelectedTemplateId(null);
        setSigning(false);
        setIframeUrl(null);
        setError(null);
        setIsStarting(false);
        setPdfLoading(false);
    };

    const handleStartSigning = async () => {
        try {
            setIsStarting(true);
            setError(null);
            // Use a hardcoded envelopeId to fetch the embedded signing URL in one call
            const hardcodedEnvelopeId = '3585c277-2adb-472b-ae8d-e53a790dae06';
            const recipientViewResp = await fetch(`http://localhost:4000/ds/envelopes/${hardcodedEnvelopeId}/recipient-view`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ recipientEmail: 'tabrez@kgrp.in', recipientName: 'Tabrez' })
            });
            if (!recipientViewResp.ok) {
                const txt = await recipientViewResp.text();
                setError(txt || 'Failed to create recipient view');
                setIsStarting(false);
                return;
            }
            const recipientData = await recipientViewResp.json() as { url?: string };
            if (!recipientData.url) {
                setError('Missing DocuSign recipient view URL');
                setIsStarting(false);
                return;
            }
            setIframeUrl(recipientData.url);
            setSigning(true);
        } catch (e:any) {
            setError(e?.message || 'Failed to start signing');
        } finally {
            setIsStarting(false);
        }
    };

    const handleDownload = async () => {
        if (!objectUrl) return;
        try {
            const response = await fetch(objectUrl, { credentials: "include" });
            if (!response.ok) throw new Error("Failed to fetch PDF");
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const anchorElement = document.createElement("a");
            anchorElement.href = blobUrl;
            anchorElement.download = selectedTemplateId ? `template-${selectedTemplateId}.pdf` : "document.pdf";
            document.body.appendChild(anchorElement);
            anchorElement.click();
            document.body.removeChild(anchorElement);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            // Fallback: open in new tab if download fails
            window.open(objectUrl, "_blank", "noopener,noreferrer");
        }
    };


    const booleanAnyAgg = (params: { values: any[] }) => params?.values?.some(Boolean) ?? false;

    const COLUMN_DEFS = [
        {
            headerName: "Entity",
            field: "entity",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            formatType: "ENTITY_WITH_LOGO",
            // rowGroup: true,
            // hide: true,

        },
        {
            headerName: "Document Type",
            field: "document_type",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            cellRenderer:(params:any)=>{
                if (params.data?.document_type?.includes("LOA")){
                    return  <div style={{display:"flex",alignItems:"center",gap:8}} ><img style={{width:20,height:20}} src={params.data?.region === "Global" ? "https://www.reshot.com/preview-assets/icons/XCGEF97ZP2/globe-XCGEF97ZP2.svg" : `https://flagcdn.com/${COUNTRY_ISO_MAP[params?.data?.region]}.svg`} alt="flag" /><Typography style={{fontWeight:600}}>{params?.data?.region} - LOA</Typography></div>

                }else{
                    return <Typography style={{fontWeight:600}}>{params?.data?.document_type}</Typography>
                }
            }
            // rowGroup: true,
            // hide: true,

        },
        // {
        //     headerName: "Region",
        //     field: "region",
        //     filter: "agTextColumnFilter",
        //     enableRowGroup: true,
        //     cellRenderer:(params:any)=>{
        //         if (params.node.group) return null;
        //         return <div style={{display:"flex",alignItems:"center",gap:8}} ><img style={{width:20,height:20}} src={params.data?.region === "Global" ? "https://www.reshot.com/preview-assets/icons/XCGEF97ZP2/globe-XCGEF97ZP2.svg" : `https://flagcdn.com/${COUNTRY_ISO_MAP[params?.data?.region]}.svg`} alt="flag" /><Typography>{params?.data?.region}</Typography></div>
        //     }

        // },
     
        {
            headerName: "Status",
            field: "loa",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            cellRenderer:(params:any)=>{
                if (params.node.group) return null;
                const disabled = !params?.data?.template_id;
                return <div style={{display:"flex",alignItems:"center",gap:8}} >
                    {params?.data?.loa ? <CheckCircleFilled  style={{color:"#27ae60",fontSize:18}}/> : <Button size="small" icon={<SignatureOutlined />} disabled={disabled} onClick={() => handleReviewSign(params)}>Review & Sign</Button>}
                </div>
            }

        },
  

    
       
      


        
       
    ];

    const rowData = [
 {
    entity:"Luminous",
    document_type:"LOA - Denmark",
    region:"Denmark",
    status:"Pending",
    status_type:"Pending",
    template_id:"2aa542a8-99ed-4431-9d78-6e2f1cb3de39",
    el:false,
    loa:false,
    nda:false
 },
 {
    entity:"Luminous",
    document_type:"LOA - France",
    region:"France",
    status:"Pending",
    status_type:"Pending",
    template_id:"2aa542a8-99ed-4431-9d78-6e2f1cb3de39",
    el:true,
    loa:true,
    nda:true

 },
 {
    entity:"Luminous",

    document_type:"LOA - Netherlands",
    region:"Netherlands",
    status:"Pending",
    status_type:"Pending",
    template_id:"2aa542a8-99ed-4431-9d78-6e2f1cb3de39",
    el:true,
    loa:true,
    nda:true

 },
 {
    entity:"Luminous",
    document_type:"LOA - United Kingdom",
    region:"United Kingdom",
    status:"Pending",
    status_type:"Pending",
    template_id:"7ecd8ffa-1571-415b-9269-fbe0c6f36be8",
    el:true,
    loa:true,
    nda:true

 },
 {
    entity:"Luminous",
    document_type:"LOA - South Korea",
    region:"South Korea",
    status:"Pending",
    status_type:"Pending",
    template_id:"7ecd8ffa-1571-415b-9269-fbe0c6f36be8",
    el:true,
    loa:true,
    nda:true

 },
 {
    entity:"Luminous",
    document_type:"NDA ",
    region:"South Korea",
    status:"Pending",
    status_type:"Pending",
    template_id:"7ecd8ffa-1571-415b-9269-fbe0c6f36be8",
    el:true,
    loa:true,
    nda:true

 },
 {
    entity:"Luminous",
    document_type:"Engagement Letter",
    region:"South Korea",
    status:"Pending",
    status_type:"Pending",
    template_id:"7ecd8ffa-1571-415b-9269-fbe0c6f36be8",
    el:true,
    loa:true,
    nda:true

 },
 {
    entity:"Luminous",
    document_type:"TRC",
    region:"South Korea",
    status:"Pending",
    status_type:"Pending",
    template_id:"7ecd8ffa-1571-415b-9269-fbe0c6f36be8",
    el:true,
    loa:true,
    nda:true

 },
 
 {
    entity:"Yatra",
    document_type:"LOA - South Korea",
    region:"South Korea",
    status:"Pending",
    status_type:"Pending",
    template_id:"7ecd8ffa-1571-415b-9269-fbe0c6f36be8",
    el:true,
    loa:true,
    nda:true

 },
 {
    entity:"Yatra",
    document_type:"LOA - Denmark",
    region:"Bahrain",
    status:"Pending",
    status_type:"Pending",
    template_id:"7ecd8ffa-1571-415b-9269-fbe0c6f36be8",
    el:true,
    loa:true,
    nda:true,
    trc:true,

 },
];

    const memoRowData = React.useMemo(() => rowData, []);

    const [columnDefsState, setColumnDefsState] = React.useState<any[] | null>(null);
    React.useEffect(() => {
        setColumnDefsState(COLUMN_DEFS);
    }, []);

    return (
        <>
           <PageHeader
           title="Document Tracker"
              showWorkspaceDropdown={false}
           />
            <div style={{flex:1}}>
                {!columnDefsState ? (
                    <div style={{height: 420, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <Spin tip="Loading table..." />
                    </div>
                ) : (
                    <AgTableClient
                    //@ts-ignore
                    columnDefs={columnDefsState}
                    rowData={memoRowData}
                    groupPanel
                    // grandTotalRow
                    enablePDFViewer
                    //showExport
                    // pinnedBottomRowData
                    
                    autoResize
                    // @ts-ignore: pass through to grid if supported by wrapper
                   defaultExpandedGroup
                />
                )}
            </div>
            <Modal
                title="Review & Sign"
                open={isModalOpen}
                onCancel={handleClose}
                footer={signing ? (
                    <div style={{display:"flex", justifyContent:"flex-end", width:"100%"}}>
                        <div style={{display:"flex", gap:8}}>
                            <Button key="close" onClick={handleClose}>Close</Button>
                        </div>
                    </div>
                ) : (
                    <div style={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                        <div>
                            <Button size="small" key="download" onClick={handleDownload} disabled={!objectUrl}>Download PDF</Button>
                        </div>
                        <div style={{display:"flex", gap:8}}>
                            <Button key="close" onClick={handleClose}>Close</Button>
                            <Button key="sign" type="primary" onClick={handleStartSigning} disabled={!selectedTemplateId || isStarting} loading={isStarting}>Start Signing</Button>
                        </div>
                    </div>
                )}
                width={900}
                destroyOnClose
                maskClosable={false}
            >
                {error ? (
                    <div style={{marginBottom: 12, color: '#cf1322'}}>{error}</div>
                ) : null}
                {!signing ? (
                    objectUrl ? (
                        <div style={{position: 'relative', width:"100%", maxHeight: 520, overflow: "auto", borderRadius: 8, border: "1px solid #f0f0f0"}}>
                            {pdfLoading ? (
                                <div style={{position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(255,255,255,0.6)', zIndex:1}}>
                                    <Spin tip="Loading document..." />
                                </div>
                            ) : null}
                            <iframe
                                src={`${objectUrl}#toolbar=0&navpanes=0&scrollbar=1`}
                                width="100%"
                                height="480"
                                style={{ border: 0 }}
                                title="PDF Preview"
                                onLoad={() => setPdfLoading(false)}
                            />
                        </div>
                    ) : null
                ) : (
                    iframeUrl ? (
                        <div style={{width:"100%", maxHeight: 520, overflow: "hidden", borderRadius: 8, border: "1px solid #f0f0f0", display: 'flex'}}>
                            <iframe
                                ref={iframeRef}
                                src={iframeUrl}
                                style={{ flex: 1, border: 'none', height: 520 }}
                                title="DocuSign Embedded Signing"
                                onLoad={() => {
                                    try {
                                        const loc = iframeRef.current?.contentWindow?.location as Location | undefined;
                                        if (loc && (loc as any).href && (loc as any).href.includes('/signing-complete.html')) {
                                            setSigning(false);
                                            setIframeUrl(null);
                                        }
                                    } catch (e) {
                                        // Cross-origin while on DocuSign domain: ignore
                                    }
                                }}
                            />
                        </div>
                    ) : null
                )}
            </Modal>
        </>
    )
};

export default DocumentTracker;
